<template>
  <footer class="app-footer">
  <!--  <span><a href="https://paramq.com">ParamQ</a> &copy; 2019.</span>-->
  
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue